<template>
  <div>
    <loading-container v-if="loading"></loading-container>

    <div v-else class="container">
      <div class="row" style="margin-bottom: 22px;">
        <div v-if="hasPermission('admin')" class="col-xs-4 col-sm-offset-12">
          <select-widget
              v-model="targetMetric"
              :options="[{value: 'publication_target', label: 'Target'}, {value: 'publication_management_target', label: 'Management Target'}]"
          ></select-widget>
        </div>

        <div class="col-xs-4" :class="hasPermission('admin') ? '' : 'col-sm-offset-16'">
          <TypeaheadWidget
              v-model="user"
              name="user_id"
              endpoint="/api/v2/users"
              :token="shared.token"
              path="data.data"
              placeholder="(all users)"
              :result-label-property="row => row.attributes.full_name"
          />
        </div>

        <div class="col-xs-4">
          <div class="dashboard-date-widget">
            <date-widget :value="year" format="YYYY" original-format="YYYY" @input="navigate"></date-widget>

            <i class="dashboard-date-widget__icon fa fa-sort"></i>
          </div>
        </div>
      </div>

      <hr class="panel-separator">

      <div class="row">
        <div class="col-sm-8">
          <index-number
              :year="year"
              :publication-based-channel="publicationBasedChannel"
              :target-metric="targetMetric"
              :user="user"
          ></index-number>
        </div>

        <div class="col-sm-8">
          <revenue-number
              :year="year"
              :publication-based-channel="publicationBasedChannel"
              :target-metric="targetMetric"
              :user="user"
          ></revenue-number>
        </div>

        <div class="col-sm-8">
          <difference-number
              :year="year"
              :publication-based-channel="publicationBasedChannel"
              :target-metric="targetMetric"
              :user="user"
          ></difference-number>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <monthly-overview
              :portal="portal"
              :year="year"
              :publication-based-channel="publicationBasedChannel"
              :filters="filters"
              :target-metric="targetMetric"
              :user="user"
          ></monthly-overview>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.dashboard-date-widget {
  position: relative;
}

.dashboard-date-widget__icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
</style>

<script>
import http from '@/http'
import store from '@/store'
import DateWidget from '@/vendor/forms/FormGroups/Widgets/Date'
import DifferenceNumber
  from '@/pages/Administration/Portals/Edit/Tabs/PublicationBasedChannelDashboard/Panels/DifferenceNumber'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import IndexNumber from '@/pages/Administration/Portals/Edit/Tabs/PublicationBasedChannelDashboard/Panels/IndexNumber'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import MonthlyOverview
  from '@/pages/Administration/Portals/Edit/Tabs/PublicationBasedChannelDashboard/Panels/MonthlyOverview'
import Permissions from '@/mixins/Permissions'
import RevenueNumber
  from '@/pages/Administration/Portals/Edit/Tabs/PublicationBasedChannelDashboard/Panels/RevenueNumber'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TypeaheadWidget from "../../../../../../vendor/forms/FormGroups/Widgets/Typeahead.vue";

export default {
  components: {
    TypeaheadWidget,
    DateWidget,
    DifferenceNumber,
    HeadlineContainer,
    IndexNumber,
    LoadingContainer,
    MonthlyOverview,
    RevenueNumber,
    SelectWidget
  },

  mixins: [Permissions],

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: ['portal', 'year', 'publicationBasedChannelId'],

  data() {
    return {
      targetMetric: 'publication_target',
      user: null,
      users: null,
      publicationBasedChannel: null,
      loading: true,
      shared: store
    }
  },

  mounted() {
    http.get('/api/v2/publication-based-channels/' + this.publicationBasedChannelId).then(response => {
      this.publicationBasedChannel = response.data.data

      this.loading = false
    })
  },

  computed: {
    filters() {
      return [
        {dimension: 'publication_based_channel_id', value: this.publicationBasedChannelId},
      ]
    }
  },

  methods: {
    navigate(year) {
      this.$router.push(year)
    }
  }
}
</script>
